import { postMultiPartFormData } from "./base-api";
import ApiUris from "./apiUris";

/**
 * Support Api method declarations
 */
export const SupportAPi = {
  supportData(request) {
    return postMultiPartFormData(ApiUris.supportMailApi.support, request);
  },
};
